import { Vec3 } from "cannon-es";
import { readable, writable } from "svelte/store";
import { toVec3 } from "./conversion-fns";
export function writableVec3(x, y, z) {
    const $value = new Vec3();
    if (typeof y !== "undefined") {
        $value.set(x, y, z);
    }
    else if (typeof x !== "undefined") {
        if (Array.isArray(x)) {
            $value.set(x[0], x[1], x[2]);
        }
        else {
            $value.copy(x);
        }
    }
    const value = writable($value);
    const store = {
        subscribe: value.subscribe,
        // eslint-disable-next-line @typescript-eslint/no-shadow
        set(x, y, z) {
            if (x !== $value &&
                x instanceof Vec3 &&
                $value.almostEquals(x, store.precision)) {
                return;
            }
            if (typeof y !== "undefined") {
                $value.set(x, y, z);
            }
            else if (Array.isArray(x)) {
                $value.set(x[0], x[1], x[2]);
            }
            else {
                $value.copy(x);
            }
            value.set($value);
        },
        update(updater) {
            value.set(toVec3(updater($value)));
        },
        precision: 0.001,
    };
    return store;
}
export function createDpad(keyMap = {
    ArrowUp: "up",
    ArrowDown: "down",
    ArrowLeft: "left",
    ArrowRight: "right",
    w: "up",
    a: "left",
    s: "down",
    d: "right",
}) {
    const pressed = {
        up: false,
        down: false,
        left: false,
        right: false,
    };
    const store = readable(pressed, (set) => {
        function onKeydown(e) {
            const direction = keyMap[e.key];
            if (direction && !pressed[direction]) {
                pressed[direction] = true;
                set(pressed);
            }
        }
        function onKeyup(e) {
            const direction = keyMap[e.key];
            if (direction && pressed[direction]) {
                pressed[direction] = false;
                set(pressed);
            }
        }
        if (typeof window !== "undefined") {
            window.addEventListener("keydown", onKeydown);
            window.addEventListener("keyup", onKeyup);
            return () => {
                window.removeEventListener("keydown", onKeydown);
                window.removeEventListener("keyup", onKeyup);
            };
        }
        return undefined;
    });
    return store;
}
